import { render, staticRenderFns } from "./MoleculeContentNodeBlockDocument.vue?vue&type=template&id=b8105906&"
import script from "./MoleculeContentNodeBlockDocument.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentNodeBlockDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports